import React, { useState } from "react";
import SuccesForm from "./SuccesForm";
import UserForm from "./UserForm";
import Card from "./footer-card/Card";

// const s3url = process.env.REACT_APP_S3_URL;

const footerCardsData = [
  {
    apiName: "Skip Tracing",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (8).svg",
    backgroundColor: "#EDF1FF",
    borderColor: "#001C9F33",
    content: "Locate users by tracing linked phones, emails, and addresses.",
  },
  {
    apiName: "OCRProof",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (9).svg",
    backgroundColor: "#EAFFFA",
    borderColor: "#069D7B33",
    content: "Turn unreadable files into clean, usable data in seconds.",
  },
  {
    apiName: "BounceProof",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (10).svg",
    backgroundColor: "#FFFBF4",
    borderColor: "#D18A1A33",
    content: "Catch bad emails before they derail your next big campaign.",
  },
  {
    apiName: "Face Match",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (11).svg",
    backgroundColor: "#F9F6FF",
    borderColor: "#6D2FEC33",
    content: "Verify if a user’s selfie matches their submitted ID photo.",
  },
  {
    apiName: "ID Proof",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (12).svg",
    backgroundColor: "#FFF2F2",
    borderColor: "#B4151733",
    content: "Validate identities in seconds before fraud slips through.",
  },
  {
    apiName: "Finnalyzer",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (13).svg",
    backgroundColor: "#FAFFF5",
    borderColor: "#94C35833",
    content: "See hidden risks in statements before approving loans or credit.",
  },
  {
    apiName: "Liveliness Check",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (14).svg",
    backgroundColor: "#F3F5FF",
    borderColor: "#001C9F33",
    content: "Confirm real presence by detecting fake photos or videos.",
  },
  {
    apiName: "Trustiify",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (15).svg",
    backgroundColor: "#FFFCF1",
    borderColor: "#FFD10633",
    content: "Know exactly who to trust with a verified identity score.",
  },
  {
    apiName: "Name Match",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (16).svg",
    backgroundColor: "#F9FFF2",
    borderColor: "#94C35833",
    content: "Confirm real presence by detecting fake photos or videos.",
  },
  {
    apiName: "Document OCR",
    apiNameStyles: { color: "#242834" },
    imageUrl: "/images/Illustration (17).svg",
    backgroundColor: "#F8F5FF",
    borderColor: "#6D2FEC33",
    content: "Extract details like name, DOB, and ID number from documents.",
  },
];

function ProductsFooter() {
  const [isUserApplied, setIsUserApplied] = useState(false);

  //   const handleredirection = useCallback((key) => {
  //     let externalUrl = {
  //       apidocs: "https://api.befisc.com",
  //       newsletter:
  //         "https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com",
  //     };

  //     window.open(externalUrl[key], "_blank", "noopener,noreferrer");
  //   }, []);

  return (
    <footer className="footer-wrapper">
      {/* forms and cto details */}
      <div className="footer-form">
        <img
          src="/images/Book demo.svg"
          alt="cto_images"
          className="cto-details-img"
          loading="lazy"
          decoding="async"
        />
        {isUserApplied ? (
          <SuccesForm />
        ) : (
          <UserForm userApplied={setIsUserApplied} />
        )}
      </div>
      <div className="footer-copyrights">
        <div className="footer-builtwith">
          <span>Fraud </span>
          Doesn’t Belong in Your System
        </div>
        <p className="id-footer-text">
          Strengthen your onboarding with APIs that keep fraud out and trust in.
        </p>
        <div
          style={{ display: "flex", flexDirection: "column", gap: "2.1rem" }}
        >
          <div className="footer-links" style={{ cursor: "pointer" }}>
            <a href="/term&condition">Privacy Policy</a>
            <a href="/billing&refunds">Billing & Refunds</a>
          </div>
          <div className="footer-rights">
            <p>© {new Date().getFullYear()} All rights reserved</p>
            <p>
              HQ: 3rd Floor, Tower C, The Iconic Corenthum Building, Sector 62,
              Noida, U.P. - 201301
            </p>
            {/* <p className="contact-info">
              <span>Contact Us: Email - info@befisc.com |</span>
              <span>Mobile +91 1204150412 &nbsp;| |&nbsp; +91 9599024885</span>
            </p> */}
          </div>
        </div>
      </div>

      <div className="flex-cards-footer">
        {footerCardsData.map((cardData, index) => (
          <Card
            key={index}
            apiName={cardData.apiName}
            apiNameStyles={cardData.apiNameStyles}
            imageUrl={cardData.imageUrl}
            backgroundColor={cardData.backgroundColor}
            borderColor={cardData.borderColor}
            content={cardData.content}
          />
        ))}
      </div>
    </footer>
  );
}

export default React.memo(ProductsFooter);
